import React from 'react';
import * as Format from '../../utils/format';

export default ({ tel }) => <a href={Format.callTelNumber(tel, true)}>{Format.telNumber(tel)}</a>
